import { render } from "./MyData.vue?vue&type=template&id=23dbd202&scoped=true"
import script from "./MyData.vue?vue&type=script&lang=js"
export * from "./MyData.vue?vue&type=script&lang=js"

import "./MyData.vue?vue&type=style&index=0&id=23dbd202&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23dbd202"]])

export default __exports__